/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Warehouse_Selector_DescriptionInputs */

const en_audit_warehouse_selector_description = /** @type {(inputs: Audit_Warehouse_Selector_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a warehouse to audit or select "All Locations" to audit everything.`)
};

const es_audit_warehouse_selector_description = /** @type {(inputs: Audit_Warehouse_Selector_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elija un almacen para auditar o seleccione "Todas las Ubicaciones" para auditar todo.`)
};

/**
* | output |
* | --- |
* | "Choose a warehouse to audit or select \"All Locations\" to audit everything." |
*
* @param {Audit_Warehouse_Selector_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_warehouse_selector_description = /** @type {((inputs?: Audit_Warehouse_Selector_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Warehouse_Selector_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_warehouse_selector_description(inputs)
	return es_audit_warehouse_selector_description(inputs)
});